import { Box, CircularProgress, FormControl, MenuItem, Select } from '@mui/material';

import { useLanguage } from 'contexts/LanguageContext';
import { useTranslationStatus } from 'contexts/TranslationProvider';

// ==============================|| DRAWER LANGUAGE PICKER ||============================== //

const LANGUAGE_OPTIONS = [
  { value: 'en', label: '🌐 English' },
  { value: 'ko', label: '🇰🇷 한국어' },
  { value: 'hi', label: '🇮🇳 हिन्दी' },
  { value: 'kn', label: '🇮🇳 ಕನ್ನಡ' },
  { value: 'ta', label: '🇮🇳 தமிழ்' },
  { value: 'te', label: '🇮🇳 తెలుగు' }
];

const DrawerLanguage = () => {
  const { language, setLanguage } = useLanguage();
  const { isTranslating } = useTranslationStatus();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, px: 2, py: 1 }} data-no-translate="true">
      {isTranslating && <CircularProgress size={16} sx={{ color: 'white' }} />}
      <FormControl size="small" fullWidth>
        <Select
          value={language}
          onChange={(e) => setLanguage(e.target.value as string)}
          displayEmpty
          disabled={isTranslating}
          renderValue={(selected) => LANGUAGE_OPTIONS.find((o) => o.value === selected)?.label || '🌐 English'}
          sx={{
            color: 'white',
            opacity: isTranslating ? 0.6 : 1,
            '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.3)' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.6)' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
            '.MuiSvgIcon-root': { color: 'white' }
          }}
        >
          {LANGUAGE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default DrawerLanguage;
